@use '@/shared/styles/theme' as *;

.pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px 0;
  flex-wrap: wrap;
}

.pagination-info {
  display: flex;
  align-items: center;
}

.limit-dropdown {
  min-width: 80px;
}

.pagination-controls {
  display: flex;
  align-items: center;
  gap: 8px;
}

.page-numbers {
  display: flex;
  align-items: center;
  gap: 4px;
}

.page-button {
  min-width: 36px;
  height: 36px;
  padding: 0 8px;
}

.nav-button {
  min-width: 36px;
  height: 36px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ellipsis {
  @include text-6px-regular;
  color: var(--secondary_text);
  padding: 0 4px;
  display: flex;
  align-items: center;
  height: 36px;
}

@media (max-width: 768px) {
  .pagination {
    flex-direction: column;
    align-items: stretch;
  }

  .pagination-info {
    justify-content: space-between;
    width: 100%;
  }

  .pagination-controls {
    justify-content: center;
    width: 100%;
  }
}
